import { Injectable, signal } from '@angular/core';
import { uid } from '../utils/mock';
import type { RiskTone } from '../models/types';

export interface DialogState {
  id: string;
  title: string;
  message: string;
  tone?: RiskTone;
  confirmLabel?: string;
  cancelLabel?: string;
  details?: string[];
  onConfirm?: () => void;
}

@Injectable({ providedIn: 'root' })
export class DialogService {
  readonly dialog = signal<DialogState | null>(null);

  /** Opens a confirmation-style dialog. Returns true/false via onConfirm. */
  confirm(config: Omit<DialogState, 'id'>): void {
    this.dialog.set({ ...config, id: uid('dlg'), confirmLabel: config.confirmLabel ?? 'Confirm', cancelLabel: config.cancelLabel ?? 'Cancel' });
  }

  close(): void {
    this.dialog.set(null);
  }

  runConfirm(): void {
    const current = this.dialog();
    if (!current) return;
    const run = current.onConfirm;
    this.close();
    run?.();
  }
}
